<template>
	<!-- 财务审核 -->
	<div class="billOperationRecord public_Spacing">
		<div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
			<div class="public_criteriaRange">
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">申请人：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="customerMo" placeholder="请选择"
						filterable>
						<el-option v-for="(item, index) in customerOptions" :key="index" :label="item.ORMTB421CA06"
							:value="item.ORMTB421CA08">
						</el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">申请类型：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择"
						filterable>
						<el-option v-for="item in materielOptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">审核状态：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="ORMTB421CA14" placeholder="请选择">
						<el-option v-for="item in dataStatusOperation" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="public_operatArea">
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive ? 'public_dateActive' : ''"
					@click="getNowDay">当日</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateYesterdayActive ? 'public_dateActive' : ''" @click="getYesterday">昨天</span>
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive ? 'public_dateActive' : ''"
					@click="sameMonth">当月</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateLastMonthActive ? 'public_dateActive' : ''" @click="lastMonth">上月</span>
				<div class="public_operatArea_timePicker pulic_cursor">
					<el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
						:picker-options="startDateDisabled" @change="datePickerChange" start-placeholder="开始日"
						end-placeholder="结束日" class="pulic_cursor">
					</el-date-picker>
				</div>
				<div class="public_operatBtn">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" v-shiroHiden="solelist"
						id="查询"><i class="iconfont icon-chaxun"></i>查询</button>
					<button class="public_saleWater_daochu pulic_cursor" @click="exports" v-shiroHiden="solelist"
						id="导出"><i class="iconfont icon-daochu"></i>导出</button>
				</div>
			</div>
		</div>
		<div class="billOperationRecord-table pulbic_table_container">
			<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;" max-height="90%"
				:default-sort="{ prop: 'waterNum', order: 'descending' }"
				:header-cell-style="{ color: 'rgba(51,51,51,1)', 'font-weight': 'bold' }" class="public_tableColumn">
				<el-table-column prop="ORMTB421CA06" label="申请人">
					<template slot-scope="scope">
						<p>
							<span>{{ scope.row.ORMTB421CA06 }}</span>
						</p>
						<p style="color: #999;">
							<span>{{ scope.row.ORMTB421CA99 }}</span>
						</p>

					</template>
				</el-table-column>
				<el-table-column prop="ORMTB421CA07" label="申请人类型">

				</el-table-column>
				<el-table-column prop="ORMTB421CA20" label="提现类型">
					<template slot-scope="scope">
						<p v-if="scope.row.ORMTB421CA20 == 0">
							<span>人工审核</span>
						</p>
						<p v-if="scope.row.ORMTB421CA20 == 1">
							<span>原路退回</span>
						</p>
						<p v-if="scope.row.ORMTB421CA20 == 2">
							<span>运费提现</span>
						</p>
					</template>
				</el-table-column>
				<el-table-column v-for='(item, index) in tableHeadList'
					:width="item.prop === 'ORMTB410CB20' ? '200' : item.prop === 'ORMTB421CA98' ? '200' : item.prop === 'ORMTB410CA07' ? '200' : ''"
					:prop="item.prop" :label="item.label" :key="index">
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin"
							v-if="(scope.row.ORMTB421CA00 == '提现' || scope.row.ORMTB421CA00 == '回款') && scope.row.ORMTB421CA14 == '审核中'"
							type="primary" size="small" @click="isorderAudit(scope.row)" v-shiroHiden="solelist"
							id="审核">审核</el-button>
						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin" type="primary"
							v-if="scope.row.ORMTB421CA00 == '提现' || scope.row.ORMTB421CA00 == '回款'" size="small"
							@click="DetailsClick(scope.row)">详情</el-button>
						<el-button class="public_icon_xiangqing public_icon_width  public_icon_margin" type="primary" size="small" 
							v-if="scope.row.ORMTB421CA25 && scope.row.ORMTB421CA25 > 0"
							@click="refundClick(scope.row)">导出退款明细</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>
		<!-- 提现 -->
		<div class="public-dialog">
			<el-dialog title="提现详情" :visible.sync="oerderDetilsShow" width="45%" @close="detailsList = ''"
				:closeOnClickModal='false'>
				<div class="DetailsWater-Dialog" style="margin-bottom: 50px;">
					<div class="DWD-li">
						<div></div>
						<div></div>

					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA05 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA06 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人类型</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA07 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">提现类型</div>
						<div v-if="detailsList.ORMTB421CA20 == 0" class="DWD-li-text">人工审核</div>
						<div v-if="detailsList.ORMTB421CA20 == 1" class="DWD-li-text">原路退回</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请提现金额</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA02 || 0 }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">手续费</div>
						<div class="DWD-li-text">{{ detailsList.sxf || 0 }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">实际打款</div>
						<div class="DWD-li-text">{{ detailsList.dk || 0 }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">到账类型</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA11 }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">账号</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA12 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">收款人</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA13 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请备注</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA04 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核备注</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA18 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核人</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA17 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核时间</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA16 || '' }}</div>
					</div>
					<div class="DWD-li" style="height: 80px;color: #fff;" v-if="DetailsWaterurl != ''">
						<div class="DWD-li-title" style="height: 80px;line-height: 80px;color:#333 ;">凭证记录</div>
						<el-image v-for="(items, indexs) in DetailsWaterurl" :key="indexs"
							style="width: 80px; height: 80px" :src="items.url" :preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
					<div class="DWD-li" v-else>
						<div class="DWD-li-title">凭证记录</div>
						<div class="DWD-li-text"></div>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="提现审核" :visible.sync="isorderAuditShow"
				@close="detailsList = '', isorderAuditText = '', imageUrl = ''" width="50%" :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA05 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA06 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人类型</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA07 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">提现类型</div>
						<div v-if="detailsList.ORMTB421CA20 == 0" class="DWD-li-text">人工审核</div>
						<div v-if="detailsList.ORMTB421CA20 == 1" class="DWD-li-text">原路退回</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">可提现金额</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA98 || 0 }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请提现金额</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA02 || 0 }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">手续费</div>
						<div class="DWD-li-text">{{ detailsList.sxf || 0 }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">实际打款</div>
						<div class="DWD-li-text">{{ detailsList.dk || 0 }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">到账类型</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA11 }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">账号</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA12 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">收款人</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA13 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请备注</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB421CA04 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核备注</div>
						<div class="DWD-li-text">
							<input type="text" v-model="isorderAuditText" maxlength="20">
						</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">实际提现金额</div>
						<div class="DWD-li-text">
							<input type="text" v-model="sjtxje" maxlength="20">
						</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">DM取现余额</div>
						<div class="DWD-li-text">{{ detailsList.dm || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">实际提现备注</div>
						<div class="DWD-li-text">
							<input type="text" v-model="sjtxjenotes" maxlength="20">
						</div>
					</div>
					<!-- <div class="DWD-li">
						<div class="DWD-li-title">线上可退款金额</div>
						<div class="DWD-li-text">{{ detailsList.zxktk || '' }}</div>
					</div> -->
				</div>
				<div class="DetailsWater-img">
					<div class="DetailsWater-img-text">上传提现凭证</div>
					<el-upload class="avatar-uploader" action="#" :auto-upload="false" :on-change="handleChangeAdd"
						list-type="picture-card" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
						<!-- <img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
						<i class="el-icon-plus"></i>
					</el-upload>

				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="isorderAuditServe(1)">通过</el-button>
					<el-button type="danger" @click="isorderAuditServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div>
		<!-- 充值 -->
		<!-- <div class="public-dialog">
			<el-dialog title="充值详情" :visible.sync="oerderDetilsShow" width="35%" @close="detailsList=''"  :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog" style="margin-bottom: 50px;">
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人类型</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值金额</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CF00=='ZG'?'直供':detailsList.ORMTB440CF00=='LS'?'零售':detailsList.ORMTB440CF00=='QD'?'抢单':''}}</div>
					</div>
					<div class="DWD-li" style="height: 80px">
						<div class="DWD-li-title" style="height: 80px;line-height: 80px;">充值记录</div>
						<el-image
						    style="width: 80px; height: 80px"
						    :src="DetailsWaterurl" 
						    :preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CC00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CE00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CD01||''}}</div>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="充值审核" :visible.sync="isorderAuditShow" @close="detailsList='',isorderAuditText=''" width="30%"  :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">申请时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA00||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA05||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">申请人类型</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA03||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值金额</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CA01||''}}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">充值备注</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CF00=='ZG'?'直供':detailsList.ORMTB440CF00=='LS'?'零售':detailsList.ORMTB440CF00=='QD'?'抢单':''}}</div>
					</div>
					<div class="DWD-li" style="height: 80px">
						<div class="DWD-li-title" style="height: 80px;line-height: 80px;">充值记录</div>
						<el-image
						    style="width: 80px; height: 80px"
						    :src="DetailsWaterurl" 
						    :preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核说明</div>
						<div class="DWD-li-text">
							<input  type="text" v-model="isorderAuditText" maxlength="20" >
						</div>
					</div>
					
				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="isorderAuditServe(1)">通过</el-button>
					<el-button type="danger" @click="isorderAuditServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div> -->
		<!--  -->
	</div>
</template>

<script>
export default {
	data() {
		return {
			isorderAuditText: '',
			sjtxje: '',
			sjtxjenotes: '',
			ORMTB421ID: '',
			oerderDetilsShow: false,
			isorderAuditShow: false,
			uobj: this.$store.state.uobj, //登陆缓存--用户信息
			date: [], //日期
			dateNowDayActive: false,
			dateYesterdayActive: false,
			dateNowMonthActive: false,
			dateLastMonthActive: false,
			tableData: [],
			materialOptions: [],
			materialTypeValue: '',
			customerOptions: [],
			carNum: '',
			materielMo: '',
			materielOptions: [{
				value: '',
				label: '全部',
			}, {
				value: 'TX',
				label: '提现',
			},
			{
				value: 'HK',
				label: '回款',
			}
			],
			// 状态
			dataStatusOperation: [{
				value: '',
				label: '全部',
			}, {
				value: '0',
				label: '审核中',
			}, {
				value: '1',
				label: '通过',
			}, {
				value: '2',
				label: '拒绝',
			}],
			// 查询
			customerMo: '', //客户--查询		
			ORMTB421CA14: '', //数据状态
			billOperationAdd: false,
			pageMo: 1, //默认列表页码
			limitMo: 10, //每页的条数
			pagingPageMo: 0, //分页--数据列表共有的条数
			currentPage: 1, //设置当前页默认为1
			tableHeadList: [
				{
					prop: 'ORMTB421CA00',
					label: '申请类型',
				},
				{
					prop: 'ORMTB421CA02',
					label: '金额',
				},
				{
					prop: 'ORMTB410CB20',
					label: '运费账户可提现金额'
				},
				{
					prop: 'ORMTB421CA98',
					label: '充值账户可提现金额',
				},
				{
					prop: 'ORMTB410CA07',
					label: '能源金可提现金额',
				},
				{
					prop: 'ORMTB421CA14',
					label: '审核状态',
				},
				{
					prop: 'ORMTB421CA16',
					label: '审核时间',
				},
				{
					prop: 'ORMTB421CA17',
					label: '审核人',
				},
			],
			// 审核
			imageUrl: '',
			// 详情
			billOperationDetails: false,
			detailsList: '', //详情列表
			isRefresh: true,
			isRefreshSetInterval: '',
			// quanpDisabled: false,
			// 历史缓存
			currentUrl: this.$route.path,
			historyInfo: '',
			// 时间限制
			// 限制开始日期不能超过当前日期
			startDateDisabled: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				}
			},
			solelist: [],
			DetailsWaterurl: '',
			DetailsWatersrcList: []
		}
	},
	created() {
		var list = "";
		list = this.$store.state.solelist;
		// 赋值，缓存销毁
		this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
		sessionStorage.removeItem(this.currentUrl)
		if (this.historyInfo != null && this.historyInfo != '') {
			this.init()
		} else {
			this.getNowDay();
		}
		var path = this.$route.path;
		if (path === '/SalesDispatchManagement') {
			path = '/Home' + path
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
	},
	mounted() {
		this.enterprise0ptions()
		this.pageList()
	},
	// 存储数据
	beforeDestroy() {
		var obj = {
			startTime: [this.date[0], this.date[1]], //开始时间
			customerMo: this.customerMo, //申请人
			materielMo: this.materielMo, //申请类型
			ORMTB421CA14: this.ORMTB421CA14, //审核状态
			currentPage: this.currentPage, //当前页数
			pageMo: this.pageMo, //页码
			limitMo: this.limitMo, //每页条数
			dateNowDayActive: this.dateNowDayActive,
			dateYesterdayActive: this.dateYesterdayActive,
			dateNowMonthActive: this.dateNowMonthActive,
			dateLastMonthActive: this.dateLastMonthActive,
		}
		sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
	},
	methods: {
		//初始化数据
		init() {
			this.date = this.historyInfo.startTime
			this.customerMo = this.historyInfo.customerMo
			this.materielMo = this.historyInfo.materielMo
			this.ORMTB421CA14 = this.historyInfo.ORMTB421CA14
			this.currentPage = this.historyInfo.currentPage
			this.pageMo = this.historyInfo.pageMo
			this.limitMo = this.historyInfo.limitMo
			this.dateNowDayActive = this.historyInfo.dateNowDayActive
			this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
			this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
			this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
		},
		// 上传图片
		handleChangeAdd(file, image) {
			this.imageUrl = image;
			// console.log(this.imageUrl)
		},
		// 导出退款明细
		refundClick(row){
			var url = `https://feishazoushi.cn/api/orm/ormtb422/exportDetail?sqr=${row.ORMTB421CA06}&&ORMTB421ID=${row.
ORMTB421ID}`
			window.location.href = url;
		},
		// 导出
		exports() {
			var startTime = this.date[0]; //开始时间
			var endTime = this.date[1]; //结束时间
			var ORMTB421CA08 = this.customerMo; //二级客户ID
			var ORMTB421CA00 = this.materielMo; //物料ID
			var ORMTB421CA14 = this.ORMTB421CA14; //状态
			var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb421toExcle?startTime=" + startTime + "&endTime=" +
				endTime + "&ORMTB421CA08=" + ORMTB421CA08 + "&ORMTB421CA00=" + ORMTB421CA00 + "&ORMTB421CA14=" + ORMTB421CA14;
			window.location.href = url;
		},
		// 申请人--查询
		enterprise0ptions() {
			var List = [{
				ORMTB421CA08: '',
				ORMTB421CA06: '全部',
			}];
			var url = "/orm/ormtb421/selectOrmtb421CA06List";
			this.axios.post(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.customerOptions = [...List, ...res.data.data];
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			})
		},
		// 查询
		queryClick() {
			this.pageList()
		},
		// 列表
		pageList() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				startTime: this.date[0], //开始时间
				endTime: this.date[1], //结束时间
				ORMTB421CA08: this.customerMo, //申请人ID
				// ORMTB400CA03: this.uobj.ormtb400.ORMTB400CA03, //一级客户代码
				ORMTB421CA00: this.materielMo, //物料ID
				ORMTB421CA14: this.ORMTB421CA14, //状态
				page: this.pageMo,
				limit: this.limitMo
			}
			this.tableData = [];
			var url = "/orm/ormtb421/selectOrmtb421PageList";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					var data = res.data.data;
					this.tableData = data;
					this.pagingPageMo = res.data.count;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		// 详情
		DetailsClick(row) {
			this.oerderDetilsShow = true;
			this.querydetileTX(row)
		},
		isorderAudit(row) {
			this.isorderAuditShow = true
			this.ORMTB421ID = row.ORMTB421ID
			this.querydetileTX(row)
		},
		isorderAuditServe(type) {
			if (type == 2) {
				if (this.isorderAuditText.trim().length == 0) return this.$message.error('请填写审核备注')
			}
			// console.log(this.imageUrl)
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var formdata = new FormData()
			formdata.append('ORMTB421CA14', type)
			formdata.append('ORMTB421CA08', this.detailsList.ORMTB421CA08)
			formdata.append('ORMTB421CA02', this.detailsList.ORMTB421CA02)
			formdata.append('ORMTB421CA09', this.detailsList.ORMTB421CA06)
			formdata.append('ORMTB421ID', this.ORMTB421ID)
			formdata.append('ORMTB421CA18', this.isorderAuditText)
			formdata.append('ORMTB421CA21', this.sjtxje)
			formdata.append('ORMTB421CA22', this.sjtxjenotes)
			if (this.imageUrl != '') {
				this.imageUrl.forEach(item => {
					formdata.append('file', item.raw)
				})
			} else {
				formdata.append('file', '')
			}
			this.tableData = [];
			if (this.detailsList.ORMTB421CA07 == '司机') {
				var url = "/orm/ormtb421/examine";
			} else {
				var url = "/orm/ormtb421/examineOrmtb410";
			}
			this.axios.post(url, formdata, {
				headers: {
					"Content-Type": "multipart/form-data",
				}
			}).then(res => {
				// console.log(res)
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					this.$message({
						message: '审核成功',
						type: 'success'
					});
					this.isorderAuditShow = false
					this.pageList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		// 提现详情
		querydetileTX(row) {
			var postData = {
				ORMTB421ID: row.ORMTB421ID, //id
			}
			this.detailsList = ''
			var url = "/orm/ormtb421/selectOrmtb421ById";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.detailsList = res.data.data;
					console.log(this.detailsList)
					if (this.detailsList.ORMTB421CA19 != '') {
						this.detailsList.ORMTB421CA19.forEach(item => {
							this.DetailsWatersrcList.push(item.url)
							console.log(item.url)
						})
						this.DetailsWaterurl = this.detailsList.ORMTB421CA19
					} else {
						this.DetailsWatersrcList = []
						this.DetailsWaterurl = ''
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}

			})
		},
		//获取当前时间
		getNowDay() {
			var date = new Date().getTime();
			var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(date));
			this.date = [nowDay, nowDay];
			this.dateNowDayActive = true
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		datePickerChange(e) {
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		//获取昨天时间
		getYesterday() {
			var hms = new Date().getTime() - 86400000;
			var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
			this.date = [nowDay, nowDay];
			this.dateNowDayActive = false
			this.dateYesterdayActive = true
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		//获取当月时间
		sameMonth() {
			var date = new Date();
			var hms = date.setDate(1);
			var firstDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
			var nextdate = new Date().getTime();
			var nextDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(nextdate));
			this.date = [firstDay, nextDay];
			this.startTime = this.date[0];
			this.endTime = this.date[1];
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = true
			this.dateLastMonthActive = false
		},
		//获取上月时间
		lastMonth() {
			var nowdays = new Date();
			var year = nowdays.getFullYear();
			var month = nowdays.getMonth();
			if (month == 0) {
				month = 12;
				year = year - 1;
			}
			if (month < 10) {
				month = "0" + month;
			}
			var firstDayOfPreMonth = year + "-" + month + "-" + "01";
			var lastDay = new Date(year, month, 0);
			let lastDayOfPreMonth = year + "-" + month + "-" + lastDay.getDate();
			this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = true
		},
		handleSizeChange(val) {
			this.pageMo = 1
			this.limitMo = val;
			this.pageList();
		},
		// 点击页码
		handleCurrentChange(val) {
			this.pageMo = val;
			this.pageList();
		},
	}
}
</script>

<style scoped>
.CustomerfillingDig-tab {
	padding-left: 20px;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
	display: flex;
	height: 50px;
	line-height: 50px;
	text-align: center;
	font-size: 16px;
	color: #333;
	vertical-align: top;
}

.CustomerfillingDig-tab-li>div {
	border: 1px solid #CDCDCD;
	border-top: none;
}

.CustomerfillingDig-tab-li>div:first-child {
	border-right: none;
}

.CustomerfillingDig-tab-li:first-child>div {
	border-top: 1px solid #CDCDCD;
}

.CustomerfillingDig-tab-li>div:last-child,
.rechargeType-tab-li>div:last-child {
	border: none;
	color: #FF4D35;
}

.CustomerfillingDig-tab-li-text {
	flex: .8;
	background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
	flex: .8;
}

.rechargeType-tab-li-text {
	flex: .35;
}

.rechargeType-tab-li-ipt {
	flex: .7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
	height: 46px;
	width: 100%;

	text-align: center;

	box-sizing: border-box;
	font-size: 16px;
	color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
	outline: none;
	border: none;
	vertical-align: top;
}

.rechargeType-tab-li-ipt input {
	/* border-radius: 8px; */
	/* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
	flex: .3;
}

.CustomerfillingDig-tab-btn {
	text-align: center;
	margin-top: 30px;
}

.DWD-li {
	display: flex;
	height: 35px;
	line-height: 35px;
	box-sizing: border-box;
	border: 1px solid #999;
	font-size: 16px;
	color: #333;
}

.DWD-li>div {
	padding: 0 5px;
	height: 34px;
	overflow: hidden;
	box-sizing: border-box;
}

.DWD-li-title {
	width: 130px;
	text-align: center;
	border-right: 1px solid #999;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-li-text {
	flex: 1;
}

.DWD-li-text input {
	width: 100%;
	height: 35px;
	line-height: 35px;
	border: none;
	outline: none;
}

.DWD-li+.DWD-li {
	border-top: none;
}

.DWD-table {
	display: flex;
}

.DWD-table-left-flex {
	flex: 1;
}

.DWD-table>div>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	text-align: center;
	border-right: 1px solid #999;
	border-bottom: 1px solid #999;
	box-sizing: border-box;
}

.DWD-table>div>div:first-child {
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table-left-title>div {
	width: 101px;
	text-align: center;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table .DWD-table-left-title>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	box-sizing: border-box;
	border-left: 1px solid #999;
	border-bottom: 1px solid #999;
}

.DetailsWater-img {
	margin-top: 30px;
}

.DetailsWater-img-text {
	display: inline-block;
	width: 101px;
	text-align: center;
	vertical-align: top;
}

.car-number-add {
	/* text-transform: uppercase; */
}

.billOperationRecord-table {
	padding: 30px 20px 0;
}

.public_singleMenu .pulic_carNumber {
	margin-top: 6px;
	height: 40px;
	line-height: 40px;
	box-sizing: border-box;
	font-size: 14px;
	display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
	background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
	flex: 1.5;
}

.fontBlue {
	color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
	margin-top: 6px;
	height: 40px;
	line-height: 40px;
	box-sizing: border-box;
	font-size: 14px;
	display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
	height: 45px;
	align-items: center;
}

.billOperationRecord {
	background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
	text-align: center !important;
}
</style>
